{
  "countryOrRegion": "国家/地区",
  "defaultCountry": "中国",
  "familyName": "姓",
  "givenName": "名",
  "identityNumber": "身份证号",
  "identityPhotos": "身份证照片",
  "identityPhotoFront": "身份证正面照",
  "identityPhotoBack": "身份证反面照",
  "identityPhotoHint": "拍照时请确保身份证边框完整、图像清晰、光线均匀。每张不超过 5MB，支持 JPG、JPEG、PNG。",
  "next": "下一步",
  "previous": "上一步",
  "identityVerification": "身份认证",
  "confirmLeave": "确认离开",
  "leaveWarning": "您确定要离开吗？您目前输入的信息将会丢失。",
  "cancel": "取消",
  "recordingInstructions": "请手持身分证件并与本人摄像,以普通话在录制的视频中念出验证数字，请注意：念完验证数字后，身份证件请靠镜头拍摄一至三秒并避免反光模糊。身份证件信息与视频必须清晰可辨认，否则审核将不通过。",
  "cameraPermissionRequired": "相机或麦克风权限未开启。你可以在「设置」中更改。",
  "processingVideo": "正在处理视频…",
  "recordAgain": "重新录製",
  "submitForReview": "提交审核",
  "unableToRecordVideo": "无法录製视频",
  "unableToPlayVideo": "无法播放视频",
  "dataLoadFailed": "数据加载失败",
  "resetFailed": "重置失败",
  "reviewPending": "审核中",
  "reviewPendingDescription": "上传完成，我们会尽快对您的提交进行审核。",
  "reviewApproved": "审核通过",
  "reviewApprovedDescription": "恭喜！您的身份已通过审核。",
  "reviewRejected": "审核未通过",
  "reviewRejectedDescription": "抱歉，您的审核未通过，原因如下：",
  "fillInAgain": "重新填写",
  "uploadFailed": "上传失败，请稍后再试",
  "identityAlreadyVerified": "身份证号已被认证过",
  "verificationFailed": "身份认证失败",
  "uploadIdentityPhotos": "请上传身份证正反面照片",
  "invalidImageFormat": "图片格式不符",
  "imageTooLarge": "图片大小超过了 5MB 的限制",
  "unableToReadImage": "无法读取所选图片",
  "prepareVideo": "准备开始录製认证视频。请确保网络稳定，时长不超过15秒。为避免上传失败，建议在WiFi环境下操作。",
  "startRecording": "开始录製",
  "uploading": "上传中，请稍候。",
  "retryUpload": "重试上传"
}
